module.exports = __webpack_public_path__ + "img/cables_para_sensor.ae23b8e6.jpg";